import { formatMoney } from "@/lib/format";
import type { PublicCatalogItem } from "@/types";

const PLACEHOLDER_IMAGE =
  "https://readdy.ai/api/search-image?query=Clean%20studio%20product%20photograph%20of%20a%20heavy%20duty%20black%20truck%20tire%20standing%20upright%20on%20a%20seamless%20warm%20beige%20neutral%20background%2C%20soft%20even%20studio%20lighting%2C%20gentle%20natural%20shadow%2C%20minimal%20commercial%20catalog%20aesthetic%2C%20high%20detail&width=600&height=450&seq=public-catalog-tire-placeholder&orientation=landscape";

interface CatalogProductCardProps {
  item: PublicCatalogItem;
  showPrices: boolean;
  onOpen: (item: PublicCatalogItem) => void;
}

export default function CatalogProductCard({ item, showPrices, onOpen }: CatalogProductCardProps) {
  return (
    <button
      type="button"
      onClick={() => onOpen(item)}
      className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-100 text-left transition-colors hover:border-primary-300"
    >
      <div className="relative h-40 w-full overflow-hidden bg-background-200">
        <img
          src={item.image_url || PLACEHOLDER_IMAGE}
          alt={item.name}
          title={`${item.name} ${item.tire_size ?? ""} neumático`.trim()}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        {item.brand_name ? (
          <span className="absolute left-2 top-2 rounded-full bg-background-50/90 px-2.5 py-0.5 text-[10px] font-semibold text-foreground-700">
            {item.brand_name}
          </span>
        ) : null}
      </div>

      <div className="flex flex-1 flex-col gap-2 p-3">
        <p className="line-clamp-2 text-sm font-semibold leading-snug text-foreground-950">{item.name}</p>

        <div className="flex flex-wrap gap-1.5">
          {item.sku ? (
            <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-[10px] font-semibold text-secondary-900">
              {item.sku}
            </span>
          ) : null}
          {item.tire_size ? (
            <span className="rounded-full bg-accent-100 px-2 py-0.5 text-[10px] font-semibold text-accent-900">
              {item.tire_size}
            </span>
          ) : null}
        </div>

        <div className="mt-auto flex items-end justify-between gap-2 pt-1">
          {showPrices ? (
            <span className="font-heading text-base font-bold text-foreground-950">
              {formatMoney(item.price)}
            </span>
          ) : (
            <span className="text-xs text-foreground-500">Precio a consultar</span>
          )}
          <span className="flex items-center gap-1 text-[11px] font-semibold text-primary-600 opacity-0 transition-opacity group-hover:opacity-100">
            Ver
            <i className="ri-arrow-right-line"></i>
          </span>
        </div>
      </div>
    </button>
  );
}